module.exports = __webpack_public_path__ + "static/media/data_save.33ffd70d.png";